import { render } from "./NotificationsBar.vue?vue&type=template&id=c03a16ec&scoped=true"
import script from "./NotificationsBar.vue?vue&type=script&lang=js"
export * from "./NotificationsBar.vue?vue&type=script&lang=js"

import "./NotificationsBar.vue?vue&type=style&index=0&id=c03a16ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c03a16ec"]])

export default __exports__